import React from "react";
import {
  formatDisplayDate,
  parseLocalDate,
  toInputDateValue,
  toLocalDateString,
} from "../../utils/dateUtils";
import "./ConflictWarning.css";

export default function ConflictWarning({
  conflicts,
  chosenStartDate,
  onKeepDate,
  onUseLatestDate,
}) {
  const latestEndDateStr = conflicts.reduce((latest, c) => {
    const dateStr = toLocalDateString(c.expectedEndDate);
    if (!dateStr) return latest;
    if (!latest) return dateStr;
    return dateStr > latest ? dateStr : latest;
  }, null);

  const latestEndDate = latestEndDateStr
    ? parseLocalDate(latestEndDateStr)
    : null;

  const formattedLatest = formatDisplayDate(latestEndDate, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  const formattedChosen = formatDisplayDate(parseLocalDate(chosenStartDate), {
    day: "numeric",
    month: "short",
  });

  return (
    <div className="conflict-warning">
      <div className="conflict-warning-header">
        <span className="conflict-icon">⚠</span>
        <div>
          <p className="conflict-title">Dependency conflict</p>
          <p className="conflict-subtitle">
            This stage cannot start on {formattedChosen}
          </p>
        </div>
      </div>

      <div className="conflict-details">
        {conflicts.map((c, i) => (
          <div key={i} className="conflict-row">
            <span className="conflict-stage">{c.predecessorStageName}</span>
            <span className="conflict-arrow">→</span>
            <span className="conflict-reason">
              {c.assigneeName} is expected to finish on{" "}
              <strong>
                {formatDisplayDate(c.expectedEndDate, {
                  day: "numeric",
                  month: "short",
                })}
              </strong>
            </span>
          </div>
        ))}
      </div>

      <p className="conflict-explanation">
        The assignee cannot start this stage until the above stage
        {conflicts.length !== 1 ? "s are" : " is"} submitted. The earliest
        possible start date is <strong>{formattedLatest}</strong>.
      </p>

      <div className="conflict-actions">
        <button
          className="conflict-btn-correct"
          onClick={() => onUseLatestDate(toInputDateValue(latestEndDate))}
        >
          ✓ Set start to {formattedLatest}
        </button>
        <button className="conflict-btn-ignore" onClick={onKeepDate}>
          Keep {formattedChosen} anyway
        </button>
      </div>
    </div>
  );
}
